<script>
document.documentElement.style.fontSize = (document.documentElement.clientHeight / 720) * 10 + 'px'
export default {

  data () {
    return {
      url: this.$route.query.url
    }
  },
  mounted () {
    this.$watch(
      () => this.$route.params,
      () => {
        this.url = this.$route.query.url
      },
      { immediate: true }
    )
  }
}
</script>

<template>
  <iframe class="web" :src="url"></iframe>
</template>

<style scoped>
::-webkit-scrollbar {
  display: none;
}

.web {
  width: 104.8rem;
  height: 100%;
  border: none;
}
</style>
